import React from 'react';
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import useTitleAndDescription from "../../common/hooks/useTitleAndDescription";
import {Footer, Header} from "../common";
import {ErrorBoundary} from "react-error-boundary";
import CenterContentBox from "../Champions/ContentWrapper";
import BottomStickAd from "../ad/BottomStickAd";
import LlmContent from "./llmContent";


const Wrapper = styled.div`
`;

const ContentWrapper = styled.div`
  min-height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;



function Fallback({error, resetErrorBoundary}) {
    // Call resetErrorBoundary() to reset the error boundary and retry the render.

    return (
        <div role="alert">
            <p>Something went wrong:</p>
            <pre>{error.message}</pre>
        </div>
    );
}

const Llm = () => {
    const {t} = useTranslation();
    useTitleAndDescription({
        title: t('header.titleLLM'),
        description: t('header.titleLLMDescription'),
    })

    return (
        <Wrapper>
            <Header/>
            <ContentWrapper>
                <ErrorBoundary FallbackComponent={Fallback}>
                    <CenterContentBox disableSponsor={true}>
                        <LlmContent/>
                    </CenterContentBox>
                </ErrorBoundary>
            </ContentWrapper>
            <Footer/>
            <BottomStickAd/>
        </Wrapper>
    );
};

export default Llm;